import { cn } from "@tosize/ui";
import type { ReactNode } from "react";

interface TextDividerProps {
	children: ReactNode;
	className?: string;
	variant?: "horizontal" | "vertical";
}

export function TextDivider({ children, className, variant = "horizontal" }: TextDividerProps) {
	return (
		<div
			className={cn(
				"flex w-full items-center justify-center text-shades-dark",
				{ "flex-col": variant === "vertical" },
				className,
			)}
		>
			<span
				className={cn("bg-shades-medium-light", {
					"h-px w-full": variant === "horizontal",
					"h-full w-px": variant === "vertical",
				})}
			/>
			<span
				className={cn({
					"px-4": variant === "horizontal",
					"py-2": variant === "vertical",
				})}
			>
				{children}
			</span>
			<span
				className={cn("bg-shades-medium-light", {
					"h-px w-full": variant === "horizontal",
					"h-full w-px": variant === "vertical",
				})}
			/>
		</div>
	);
}
